import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { AppContext } from 'contexts/AppContext';

import { getPrequalifyOptions } from 'services/affordableService';

const useAsyncPrequalifyOptions = (setError) => {
  const { organizationId, propertyId } = useContext(AppContext);
  const [options, setOptions] = useState(null);

  useEffect(() => {
    const source = axios.CancelToken.source();
    let subscribed = true;

    const fetchOptions = async () => {
      const { token } = source;
      const requestOptions = { cancelToken: token };
      const response = await getPrequalifyOptions(
        organizationId,
        propertyId,
        requestOptions,
      );

      if (response.error) {
        setError(
          `[${response.status}] There was a problem retrieving prequalify options`,
        );
      } else if (subscribed) {
        const parsedOptions = response.options?.map(({ label, value }) => ({
          id: label?.split(' ')?.join('_'),
          label,
          value,
        }));
        setOptions(parsedOptions);
      }
    };

    fetchOptions();

    return () => {
      subscribed = false;
    };
  }, [organizationId, propertyId, setOptions, setError]);

  return options;
};

export default useAsyncPrequalifyOptions;
